import { useQuery } from "@tanstack/react-query";
import BinApiService from "src/api/BinApiService";
import PremierPlusTapestripDTO from "src/models/PremierPlusTapestripDTO";
import { QueryTypes } from "./shared";


export const useGetPremierPlusBinTapestripData = (binId: number, from: string | null, to: string | null, options: QueryTypes = {}) => {
    const getPremierPlusTapestripDataQueryKey = "getPremierPlusTapestripData";

    const getPremierPlusTapestripDataQuery = useQuery<PremierPlusTapestripDTO[]>({
        queryKey: [getPremierPlusTapestripDataQueryKey, binId, from, to],
        queryFn: async (q) => {

            return await BinApiService.getPremierPlusBinTapestrips(binId, from, to, q.signal);
        },
        enabled: options.enabled,
        refetchOnWindowFocus: options.refetchOnWindowFocus,
        retry: options.retry,
    });

    return { getPremierPlusTapestripDataQueryKey, getPremierPlusTapestripDataQuery };

}